import { render, staticRenderFns } from "./DiaSemanaMaiorAcesso.vue?vue&type=template&id=780a97e7&scoped=true"
import script from "./DiaSemanaMaiorAcesso.vue?vue&type=script&lang=js"
export * from "./DiaSemanaMaiorAcesso.vue?vue&type=script&lang=js"
import style0 from "./DiaSemanaMaiorAcesso.vue?vue&type=style&index=0&id=780a97e7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "780a97e7",
  null
  
)

export default component.exports